// extracted by mini-css-extract-plugin
module.exports = {"module":"object-detail_module__14guD","name":"object-detail_name__aFaJ5"};